const aplicacaoEnum = {
  APLICATIVO: 2,
  BANDEIRAS: 7
}

export default aplicacaoEnum



// WEBPACK FOOTER //
// ./client/enum/aplicacaoEnum.js